
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';
import 'swiper/css/swiper.css';

export default BaseCmsBlock.extend({
  name: 'ImageGalleryBlock',

  data: function () {
    const vnode = (Math.random() + 1).toString(36).substring(7);

    return {
      swiperOptions: {
        spaceBetween: 20,
        slidesPerView: (this.cfgs.count_m || 1) > 1 ? 1.2 : 1,
        slidesPerGroup: 1,
        loop: true,
        centeredSlides: false,
        navigation: {
          prevEl: `#button-navigation-${vnode}-prev`,
          nextEl: `#button-navigation-${vnode}-next`,
        },
        breakpoints: {
          1200: {
            spaceBetween: 30,
            slidesPerView: this.cfgs.count_m || 1,
          },
          1024: {
            spaceBetween: 20,
            slidesPerView: (this.cfgs.count_m || 1) > 1 ? 3 : 1,
          },
          860: {
            spaceBetween: 20,
            slidesPerView: (this.cfgs.count_m || 1) > 1 ? 2.8 : 1,
          },
          640: {
            spaceBetween: 20,
            slidesPerView: (this.cfgs.count_m || 1) > 1 ? 2.2 : 1,
          },
        },
      },

      vnode,
    };
  },

  components: {
    Swiper,
    SwiperSlide,
  },

  methods: {
    openPopUpImages: function (activeIndex) {
      this.$store.commit('pop-up-images/open', {
        activeIndex: activeIndex,
        images: (this.values.items || []).map((t) => t.imageId),
      });
    },
  },
});
